import { deleteFileToS3, uploadFileToS3, } from "@erp/shared/api/generated/wrappers/s3";
import { showAlert } from "@erp/shared/utils/dialog";
import { computed, ref } from "vue";
export function useFileUpload(folderName) {
    const files = ref([]);
    const uploadFiles = ref([]);
    const failedFiles = ref([]);
    const isUploading = computed(() => uploadFiles.value.some((file) => file.isUploading));
    const setFiles = (newFiles) => {
        files.value = newFiles;
    };
    const uploadSingleFile = async (file) => {
        try {
            const s3Url = await uploadFileToS3(file, folderName, false);
            const uploadFile = uploadFiles.value.find((uploadFile) => uploadFile.fileName === file.name);
            if (uploadFile) {
                uploadFile.isUploading = false;
                uploadFile.url = s3Url;
            }
        }
        catch (error) {
            const uploadFileIndex = uploadFiles.value.findIndex((uploadFile) => uploadFile.fileName === file.name);
            if (uploadFileIndex !== -1) {
                uploadFiles.value.splice(uploadFileIndex, 1);
            }
            failedFiles.value.push(file.name);
            throw error;
        }
    };
    const alertFailedFiles = () => {
        if (failedFiles.value.length > 0) {
            showAlert(`다음 이미지 업로드에 실패했습니다: ${failedFiles.value.join(", ")}\n` +
                `성공한 이미지만 저장됩니다.`, "일부 이미지 업로드 실패");
        }
    };
    const uploadS3 = async (newFiles) => {
        await Promise.allSettled(newFiles.map(async (file) => {
            if (!file || !(file instanceof File)) {
                return Promise.resolve(new Error("파일이 없습니다."));
            }
            uploadFiles.value.push({
                url: null,
                fileName: file.name,
                isUploading: true,
            });
            await uploadSingleFile(file);
        }));
        alertFailedFiles();
    };
    const deleteS3 = async (fileName) => {
        try {
            await deleteFileToS3(fileName);
            const index = uploadFiles.value.findIndex((file) => file.fileName === fileName);
            if (index !== -1) {
                uploadFiles.value.splice(index, 1);
            }
        }
        catch (error) {
            showAlert("파일 삭제에 실패했습니다. 다시 시도해주세요.", "삭제 실패");
            throw error;
        }
    };
    return {
        files,
        setFiles,
        uploadFiles,
        uploadS3,
        deleteS3,
        failedFiles,
        uploadSingleFile,
        alertFailedFiles,
        isUploading,
    };
}
